import { createContext, useContext, useState, useCallback, useRef } from "react";

// ─── Context ──────────────────────────────────────────────────────────────────
const KpiCardFontContext = createContext(null);

// ─── Provider ──────────────────────────────────────────────────────────────────
export function KpiCardFontProvider({ children }) {
  const [minFontSize, setMinFontSize] = useState(null);
  const fontSizesRef = useRef({});

  // Zaregistruje vypočítanú veľkosť fontu pre konkrétnu kartu
  // Nepoužívame useCallback, lebo sa má volať bez zmien v dependenciách
  const registerFontSize = (cardId, computedSize) => {
    fontSizesRef.current[cardId] = computedSize;
    
    // Nájdi najmenšiu veľkosť spomedzi všetkých kariet
    const sizes = Object.values(fontSizesRef.current).filter(s => s !== null && s !== undefined);
    const newMin = sizes.length > 0 ? Math.min(...sizes) : null;
    
    setMinFontSize(newMin);
  };

  return (
    <KpiCardFontContext.Provider value={{ minFontSize, registerFontSize }}>
      {children}
    </KpiCardFontContext.Provider>
  );
}

// ─── Hook ─────────────────────────────────────────────────────────────────────
export function useKpiCardFontSize() {
  const context = useContext(KpiCardFontContext);
  if (!context) {
    throw new Error("useKpiCardFontSize musí byť použitý v rámci KpiCardFontProvider");
  }
  return context;
}
